<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="ProcessWagesId"
      ref="list"
      unit="产品工序计件工价"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      urlHash="production/piecerate/productwage"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/pr/prProcessWages").default,
      trendShow: true,
      params: {
        ProcessUnitTypeName: null,
        Stage: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>